import { api } from './api';
import { ApiResponse } from './api';
import { GateEntry, CreateGateEntryData } from '../types';

export interface GateEntryFilters {
  page?: number;
  limit?: number;
  search?: string;
  shipmentType?: 'inward' | 'outward';
  status?: string;
}

export const gateEntryService = {
  createGateEntry: async (data: CreateGateEntryData): Promise<ApiResponse<GateEntry>> => {
    return api.post('/gate-entries', data);
  },

  getGateEntries: async (filters?: GateEntryFilters): Promise<ApiResponse<any>> => {
    return api.get('/gate-entries', { params: filters });
  },

  getGateEntryById: async (id: string): Promise<ApiResponse<GateEntry>> => {
    return api.get(`/gate-entries/${id}`);
  },

  updateGateEntry: async (id: string, data: Partial<CreateGateEntryData>): Promise<ApiResponse<GateEntry>> => {
    return api.patch(`/gate-entries/${id}`, data);
  },

  assignDock: async (id: string, dockNumber: string): Promise<ApiResponse<GateEntry>> => {
    return api.post(`/gate-entries/${id}/assign-dock`, { dockNumber });
  },
};